const WHERE_TO_PAY_TAB_IDS = ["shops", "e-shops", "campaigns"] as const;

export type WhereToPayTabId = (typeof WHERE_TO_PAY_TAB_IDS)[number];

export const isValidWhereToPayTab = (
  value: string | null,
): value is WhereToPayTabId =>
  value !== null && WHERE_TO_PAY_TAB_IDS.includes(value as WhereToPayTabId);
